export const PolicyDetails = "policyDetails";
export const AgriculturePolicyDetails = "agriculturePolicyDetails";
export const LocationRiskAssessment = "locationRiskAssessment";

export const enum PageTabs {
  preferredTab = "preferredTab",
  cocoOldTab = "cocoOldTab",
  cocoNewTab = "cocoNewTab",
  otherTab = "otherTab",
  warningTab = "warningTab",
  socioEnvironmentTab = "socioEnvironmentTab",
}

export const HazardSource = "hazard-source-";
export const HazardLayer = "hazard-layer-";
export const HazardLayerSecondary = "hazard-layer-secondary-";
export const HazardSourceSecondary = "hazard-source-secondary-";

export enum HazardIdEnum {
  CysNatRiskIndex = "cys_risk_index_ita_eurain_curcl_nateve",
  CysNonCatRiskIndex = "cys_risk_index_ita_eurain_curcl_nnatca",
  ANIANatRiskIndex = "rma_risk_index_ita_ania_curcl_nateve",
  ANIANonCatRiskIndex = "rma_risk_index_ita_ania_curcl_nnatca",
  //  calc hazard value from here only
  SeismicRiskHowden = "rma_risk_earth_ita_rmshow_natcat",
  InlandFloodHowden = "rma_risk_rivfl_ita_rmshow_natcat",
  InlandFloodHowden58 = "rma_risk_rivfl_ita_rmshow_natcat58",
  InlandFloodHowden56 = "rma_risk_rivfl_ita_rmshow_natcat56", // InlandFloodHowden58 2 for Reale

  LandslideRiskIspra = "rma_risk_lslde_ita_rmshow_natcat",
  InlandFloodIspra = "rma_risk_rivfl_ita_ispra_natcat",

  EarthquakeMagnitude = "cys_risk_earth_mag_ita",
  SeismicClassificationIta = "cys_risk_earth_ita_ddpc",

  InlandFloodEur10y = "cys_risk_rivfl_eur_efas_curcl_rp0010",
  InlandFloodEur20y = "cys_risk_rivfl_eur_efas_curcl_rp0020",
  InlandFloodEur30y = "cys_risk_rivfl_eur_efas_curcl_rp0030",
  InlandFloodEur40y = "cys_risk_rivfl_eur_efas_curcl_rp0040",
  InlandFloodEur50y = "cys_risk_rivfl_eur_efas_curcl_rp0050",
  InlandFloodEur75y = "cys_risk_rivfl_eur_efas_curcl_rp0075",
  InlandFloodEur100y = "cys_risk_rivfl_eur_efas_curcl_rp0100",
  InlandFloodEur200y = "cys_risk_rivfl_eur_efas_curcl_rp0200",
  InlandFloodEur500y = "cys_risk_rivfl_eur_efas_curcl_rp0500",

  InlandFloodIta10y = "cys_risk_rivfl_ita_efas_curcl_rp0010",
  InlandFloodIta20y = "cys_risk_rivfl_ita_efas_curcl_rp0020",
  InlandFloodIta30y = "cys_risk_rivfl_ita_efas_curcl_rp0030",
  InlandFloodIta40y = "cys_risk_rivfl_ita_efas_curcl_rp0040",
  InlandFloodIta50y = "cys_risk_rivfl_ita_efas_curcl_rp0050",
  InlandFloodIta75y = "cys_risk_rivfl_ita_efas_curcl_rp0075",
  InlandFloodIta100y = "cys_risk_rivfl_ita_efas_curcl_rp0100",
  InlandFloodIta200y = "cys_risk_rivfl_ita_efas_curcl_rp0200",
  InlandFloodIta500y = "cys_risk_rivfl_ita_efas_curcl_rp0500",

  InlandFloodUsa10y = "cys_risk_rivfl_usa_efas_curcl_rp0010",
  InlandFloodUsa20y = "cys_risk_rivfl_usa_efas_curcl_rp0020",
  InlandFloodUsa50y = "cys_risk_rivfl_usa_efas_curcl_rp0050",
  InlandFloodUsa75y = "cys_risk_rivfl_usa_efas_curcl_rp0075",
  InlandFloodUsa100y = "cys_risk_rivfl_usa_efas_curcl_rp0100",
  InlandFloodUsa200y = "cys_risk_rivfl_usa_efas_curcl_rp0200",
  InlandFloodUsa500y = "cys_risk_rivfl_usa_efas_curcl_rp0500",

  InlandFloodBra10y = "cys_risk_rivfl_bra_efas_curcl_rp0010",
  InlandFloodBra20y = "cys_risk_rivfl_bra_efas_curcl_rp0020",
  InlandFloodBra50y = "cys_risk_rivfl_bra_efas_curcl_rp0050",
  InlandFloodBra75y = "cys_risk_rivfl_bra_efas_curcl_rp0075",
  InlandFloodBra100y = "cys_risk_rivfl_bra_efas_curcl_rp0100",
  InlandFloodBra200y = "cys_risk_rivfl_bra_efas_curcl_rp0200",
  InlandFloodBra500y = "cys_risk_rivfl_bra_efas_curcl_rp0500",

  InlandFloodGlobal10y = "cys_risk_rivfl_wrl_glofas_curcl_rp0010",
  InlandFloodGlobal20y = "cys_risk_rivfl_wrl_glofas_curcl_rp0020",
  InlandFloodGlobal50y = "cys_risk_rivfl_wrl_glofas_curcl_rp0050",
  InlandFloodGlobal100y = "cys_risk_rivfl_wrl_glofas_curcl_rp0100",
  InlandFloodGlobal500y = "cys_risk_rivfl_wrl_glofas_curcl_rp0500",

  CoastalFlood10y = "cys_risk_cstfl_eur_eurain_rcp45_rp0010",
  CoastalFlood30y = "cys_risk_cstfl_eur_eurain_rcp45_rp0030",
  CoastalFlood100y = "cys_risk_cstfl_eur_eurain_rcp45_rp0100",
  CoastalFlood300y = "cys_risk_cstfl_eur_eurain_rcp45_rp0300",
  CoastalFlood1000y = "cys_risk_cstfl_eur_eurain_rcp45_rp1000",
  CoastalFloodEurProt = "cys_risk_cstfl_eur_eurain_rcp45_rp1000_wp",
  CoastalFloodEurNoProt = "cys_risk_cstfl_eur_eurain_rcp45_rp1000_np",
  FlashFloodIta3h = "cys_risk_flafl_eur_eurain_curcl_rp0010_3hr",
  FlashFloodIta24h = "cys_risk_flafl_eur_eurain_curcl_rp0010_24hr",
  FlashFloodIta48h = "cys_risk_flafl_eur_eurain_curcl_rp0010_48hr",
  FlashFloodIta72h = "cys_risk_flafl_eur_eurain_curcl_rp0010_72hr",
  HailEurLarge = "cys_risk_hails_eur_eurain_curcl_large",
  HailItaLarge = "cys_risk_hails_ita_eurain_curcl_large",
  HailItaLargeRcp45 = "cys_risk_hails_ita_eurain_rcp45_large",
  HailItaLargeRcp85 = "cys_risk_hails_ita_eurain_rcp85_large",
  HailItaExLarge = "cys_risk_hails_ita_eurain_curcl_exlarge",
  HailItaExLargeRcp45 = "cys_risk_hails_ita_eurain_rcp45_exlarge",
  HailItaExLargeRcp85 = "cys_risk_hails_ita_eurain_rcp85_exlarge",
  ExplosionIta = "cys_risk_explo_ita_ispra",
  HighWindItaSevere = "cys_risk_windy_ita_eurain_curcl_severe",
  HighWindItaSevereRcp45 = "cys_risk_windy_ita_eurain_rcp45_severe",
  HighWindItaSevereRcp85 = "cys_risk_windy_ita_eurain_rcp85_severe",
  HighWindItaExtreme = "cys_risk_windy_ita_eurain_curcl_exsevere",
  HighWindItaExtremeRcp45 = "cys_risk_windy_ita_eurain_rcp45_exsevere",
  HighWindItaExtremeRcp85 = "cys_risk_windy_ita_eurain_rcp85_exsevere",
  SnowIta5cm = "cys_risk_snowf_ita_eurain_rcp45_5cm",
  SnowIta25cm = "cys_risk_snowf_ita_eurain_rcp45_25cm",
  LightningStrikeIta = "cys_risk_lgtng_ita_nldn_curcl",

  WindItaANIA = "rma_risk_windy_ita_ania",
  HailItaANIA = "rma_risk_hails_ita_ania",
  LightningStrikeItaANIA = "rma_risk_lgtng_ita_ania",
  PrecipitationIta75mmANIA = "rma_risk_precp_ita_ania",
  SnowIta30cmANIA = "rma_risk_snowf_ita_ania",
  WarningLandslide = "cys_warn_lslde_ita",
  WarningRainfall1Day = "cys_warn_rainf_ita_1day",
  WarningRainfall7Day = "cys_warn_rainf_ita_7day",

  RealeGroupWind = "rma_risk_windy_ita_rmanat_curcl",
  RealeGroupHail = "rma_risk_hails_ita_rmanat_curcl",

  SeismicCoCoRma = "rma_risk_earth_ita_coco",
  FloodCoCoRma = "rma_risk_rivfl_ita_coco",
  LandslideCoCoRma = "rma_risk_lslde_ita_coco",
  SeismicCoCoIta = "ita_risk_earth_ita_coco",
  FloodCoCoIta = "ita_risk_rivfl_ita_coco",
  LandslideCoCoIta = "ita_risk_lslde_ita_coco",

  SeismicCoCo2Rma = "rma_risk_earth_ita_coco_2",
  FloodCoCo2Rma = "rma_risk_rivfl_ita_coco_2",
  LandslideCoCo2Rma = "rma_risk_lslde_ita_coco_2",
  SeismicCoCo2Ita = "ita_risk_earth_ita_coco_2",
  FloodCoCo2Ita = "ita_risk_rivfl_ita_coco_2",
  LandslideCoCo2Ita = "ita_risk_lslde_ita_coco_2",

  SeismicCoCo3Rma = "rma_risk_earth_ita_coco_3",
  FloodCoCo3Rma = "rma_risk_rivfl_ita_coco_3",
  LandslideCoCo3Rma = "rma_risk_lslde_ita_coco_3",
  SeismicCoCo3Ita = "ita_risk_earth_ita_coco_3",
  FloodCoCo3Ita = "ita_risk_rivfl_ita_coco_3",
  LandslideCoCo3Ita = "ita_risk_lslde_ita_coco_3",

  SeismicCoCo4Rma = "rma_risk_earth_ita_coco_4",
  SeismicCoCo4Ita = "ita_risk_earth_ita_coco_4",

  LandslideTodayPrc = "cys_risk_lslde_ita_prc_today",
  ThunderstormTodayPrc = "cys_risk_windy_ita_prc_today",
  FloodTodayPrc = "cys_risk_rivfl_ita_prc_today",
  LandslideTomorrowPrc = "cys_risk_lslde_ita_prc_tomorrow",
  ThunderstormTomorrowPrc = "cys_risk_windy_ita_prc_tomorrow",
  FloodTomorrowPrc = "cys_risk_rivfl_ita_prc_tomorrow",

  SeismicRiskHowden2 = "rma_risk_earth_ita_rmshow_natcat2",
  SeismicRiskGemIsl = "cys-risk-earth-isl-gem-natcat",
  SeismicRiskGemGlobal = "cys-risk-earth-wrl-gem-natcat",

  StormSurgeCat1Us = "cys_risk_storm_usa_curcl_cat1",
  WildfireVHPIndexUs = "cys_risk_wildf_usa_vhp_index",

  EnvironmentDistanceFireStation = "cys_soce_dfires",
  EnvironmentDistanceSchool = "cys_soce_dschools",

  LandCoverCropTypeEur2023 = "cys_envr_landc_eur_clms_v2023",
  LandCoverForestTypeEur2023 = "cys_envr_landf_eur_clms_v2023",
  WorldCover2021 = "cys_envr_landc_wrl_esa_v2021",

  // Digital elevation, 4 maps:

  DigitalElevationModelSwe = "cys_envr_dem_swe_copernicus_glo30",
  DigitalElevationModelIta = "cys_envr_dem_ita_copernicus_glo30",
  HeightAboveNearestDrainageSwe = "cys_envr_hand_swe_asf_copworlddem30",
  HeightAboveNearestDrainageIta = "cys_envr_hand_ita_asf_copworlddem30",

  // Population density, 3 maps:

  PopulationDensityEurStat22021 = "cys_soce_popld_eur_eurostat_v22021",
  PopulationDensityWorld = "cys_soce_popld_wrl_ornl_landscang",
  PopulationDensityUsa = "cys_soce_popld_usa_ornl_landscanusa",

  DistanceToNearestCoastWorld = "cys_envr_dcoast_wrl_nasaobpg",
  DistanceToNearestCoastIta = "cys_envr_dcoast_ita_nasaobpg",

  CrimeDatasetsSwe = "cys_soce_crime_swe_msb_2024",

  NasaCastPrecipitationIta1Day = "cys_nowc_precp_ita_nasagpm_1day",
  NasaCastPrecipitationIta3Day = "cys_nowc_precp_ita_nasagpm_3day",
  NasaCastPrecipitationIta7Day = "cys_nowc_precp_ita_nasagpm_7day",
  NasaCastLandslideIta = "cys_nowc_lslde_ita_nasagpm",
}
